import { render } from "./CallInFallback.vue?vue&type=template&id=947373a4"
import script from "./CallInFallback.vue?vue&type=script&lang=js"
export * from "./CallInFallback.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__